import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "Will the Titan U-Lock fit my e-bike frame?",
    a: "Yes. The Titan features an extended 9-inch shackle designed specifically to accommodate thicker e-bike down tubes and standard bike racks."
  },
  {
    q: "Are the bags actually 100% waterproof?",
    a: "Our 'Dry' series (AeroCommute, Messenger DryLite) utilize high-frequency welded seams and TPU-coated fabrics. They are fully submersible-proof. Ride through a monsoon worry-free."
  },
  {
    q: "How long does the LumenBlast battery last?",
    a: "On the highest steady setting (800 lumens), expect 2.5 hours. On daytime flash mode, it runs for up to 18 hours. It recharges via USB-C in about 2 hours."
  },
  {
    q: "What is your theft replacement policy?",
    a: "If your bike is stolen while properly secured with our Titan U-Lock (registered within 30 days of purchase), we cover your insurance deductible up to $500. Terms apply."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-asphalt">
      <div className="max-w-4xl mx-auto px-6">
        
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4">
            Need <span className="text-signal">Intel?</span>
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-white/10 bg-asphalt-dark rounded-sm overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className={`text-lg font-bold transition-colors ${openIndex === index ? 'text-signal' : 'text-white'}`}>
                  {faq.q}
                </span>
                <SafeIcon 
                  icon={openIndex === index ? FiMinus : FiPlus} 
                  className={`text-xl flex-shrink-0 transition-colors ${openIndex === index ? 'text-signal' : 'text-gray-500'}`} 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed border-t border-white/5 pt-4">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;